export const initialEntries = [
  {
    title: 'Lorem ipsum',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.'
  },
  {
    title: 'At vero eos',
    text: 'At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata'
  }
];
